import React, { FunctionComponent, ReactElement, memo } from 'react'
import BasicButton from '../Basic'
import { ButtonTypes } from '../ButtonTypes'
import { TestID } from '../../../../utils/PropTypesDefinitions'
import LinkProps from '../../../../Link/LinkProps'
import { FixedMarginProps } from '../../../../utils/styling/StylingHelper'

export type BigButtonProps = {
    /** text shown inside of the button */
    children: string
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * callback function triggered when button is pressed
     *
     * @TJS-type function
     */
    onPress?: () => void
    /** if expand is provided, the button expands to full width */
    expand?: boolean
    iconName?: 'play-active'
} & ButtonTypes &
    FixedMarginProps &
    LinkProps &
    TestID

const BigButton: FunctionComponent<BigButtonProps> = ({
    children,
    backgroundColor = 'pearl',
    href,
    onPress,
    expand,
    iconName,
    testID,
    webRel,
    ...rest
}): ReactElement => {
    return (
        <BasicButton
            height={44}
            paddingX={5}
            {...{
                href,
                onPress,
                expand,
                backgroundColor,
                iconName,
                testID,
                webRel,
            }}
            {...rest}
        >
            {children}
        </BasicButton>
    )
}

export default memo(BigButton)
